import {QuestionCircleOutlined} from '@ant-design/icons'
import {css} from '@emotion/react'
import Modal from './Modal.jsx'

const cssBody = css({
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    alignItems: 'center',
    overflow: 'inherit',
})

const cssIcon = css({
    color: '#1890ff',
    fontSize: 24,
    marginRight: 12,
})

const cssContent = css({
    display: 'grid',
    alignSelf: 'stretch',
    overflow: 'hidden',
})

export default function Confirm({
    children,
    icon = <QuestionCircleOutlined css={cssIcon} />,
    onOk,
    ...props
}) {
    return (
        <Modal
            title="确认"
            onOk={() => onOk(true)}
            onCancel={() => onOk(false)}
            {...props}
        >
            <div css={cssBody}>
                {icon ?? <div></div>}
                <div css={cssContent}>{children}</div>
            </div>
        </Modal>
    )
}
